import React, { useState } from 'react';
import { FC } from 'react';
import useTranslations from '@hooks/useTranslation';
import ContentTemplate from '@ui/Content/Content';
import Title from '@ui/SectionTitle/Title';
import { getMinioBaseURL } from '../../constants';
import { Background, Player } from './Video.elements';

export interface VideoProps {}

const VideoTemplate: FC<VideoProps> = () => {
    const { t } = useTranslations();

    return (
        <Background>
            <ContentTemplate withPadding>
                <Title isBlack>{t('subscription.video.title')}</Title>
                <Player controls playsInline>
                    <source src={`${getMinioBaseURL()}/static/sw-rocni-predplatne-lq.mp4`} type="video/mp4" />
                </Player>
            </ContentTemplate>
        </Background>
    );
};

export default VideoTemplate;
